var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.128,
    height: 26,
    viewBox: "0 0 18.128 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g842",
    transform: "translate(-0.035 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path835",
    d: "M37.335,50.786a25.237,25.237,0,0,1,2.048,3.026,15.821,15.821,0,0,1,1.125,2.852c.228.656.442.857.9.857.5,0,.723-.335.9-.857a16.092,16.092,0,0,1,1.084-2.8,31.32,31.32,0,0,1,3.039-4.3,26.594,26.594,0,0,0,3.012-4.338,10.563,10.563,0,0,0,1.031-4.592,9.129,9.129,0,0,0-1.018-4.244l-2.945.79L44.712,41.9l-.442.643-.094.12-.12.147-.2.241-.295.295-1.593,1.3-3.976,2.3Z",
    transform: "translate(-32.306 -31.527)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    d: "M6.635,57.641c.977,2.222,2.838,4.164,4.11,5.877l6.734-7.979a3.535,3.535,0,0,1-2.664,1.245,3.448,3.448,0,0,1-3.468-3.454,3.694,3.694,0,0,1,.79-2.236L7.572,52.312Z",
    transform: "translate(-5.716 -44.259)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831",
    d: "M53.157,3.094a8.987,8.987,0,0,1,5.3,4.472l-5.382,6.413a3.743,3.743,0,0,0,.79-2.236,3.488,3.488,0,0,0-3.454-3.454A3.625,3.625,0,0,0,47.735,9.52V5.477Z",
    transform: "translate(-41.314 -2.685)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path829",
    d: "M15.835,3.234a9,9,0,0,1,6.922-3.24,9.256,9.256,0,0,1,2.758.415L20.106,6.835H16.277Z",
    transform: "translate(-13.685 0)",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path827",
    d: "M.919,34.429a10.364,10.364,0,0,1-.884-4.284,9.015,9.015,0,0,1,2.129-5.851l4.271,3.6Z",
    transform: "translate(0 -21.047)",
    fill: "#ea4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalPin);
export default __webpack_public_path__ + "static/media/localPin.3cefd67051dd817a7617e6f549375dd9.svg";
export { ForwardRef as ReactComponent };